"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultGift = exports.getIsDefaultGiftLoading = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var getDefaultGiftState = function getDefaultGiftState(state) {
  return state.modules.giftingOnTheFly.campaign.defaultGift;
};

var getIsDefaultGiftLoading = (0, _ramda.pipe)(getDefaultGiftState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsDefaultGiftLoading = getIsDefaultGiftLoading;
var getDefaultGift = (0, _ramda.pipe)(getDefaultGiftState, function (state) {
  return state.defaultGift;
});
exports.getDefaultGift = getDefaultGift;